"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    jwtPlugin: ()=>jwtPlugin
});
const index_js_namespaceObject = require("../../domain-id/index.js");
const external_tool_js_namespaceObject = require("../../tool.js");
const external_jwt_index_js_namespaceObject = require("../../jwt/index.js");
const RESPONSE_JWT_KEY = 'X-Jwt-Token';
function jwtPlugin(jwtConfig) {
    return {
        request: [
            async (config)=>{
                var _config_pluginConfig, _config_pluginConfig1, _config_pluginConfig2;
                var _config_pluginConfig_disableJwtPlugin;
                if (null != (_config_pluginConfig_disableJwtPlugin = null == config ? void 0 : null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.disableJwtPlugin) ? _config_pluginConfig_disableJwtPlugin : null == (_config_pluginConfig1 = config.pluginConfig) ? void 0 : _config_pluginConfig1.jwtDisabled) return config;
                var _config_pluginConfig_domainID, _ref;
                const domainID = null != (_ref = null != (_config_pluginConfig_domainID = null == (_config_pluginConfig2 = config.pluginConfig) ? void 0 : _config_pluginConfig2.domainID) ? _config_pluginConfig_domainID : null == jwtConfig ? void 0 : jwtConfig.domainID) ? _ref : (0, external_tool_js_namespaceObject.tryCatch)(index_js_namespaceObject.getCurrentDomainID, (error)=>{
                    console.error({
                        message: null == error ? void 0 : error.message,
                        position: 'jwtPlugin',
                        context: {
                            jwtPluginConfig: jwtConfig,
                            globalPluginConfig: config.pluginConfig,
                            currentDomainID: index_js_namespaceObject.currentDomainID
                        }
                    });
                    throw error;
                });
                const jwt = await (0, external_jwt_index_js_namespaceObject.getJwt)(domainID);
                var _config_headers;
                config.headers = null != (_config_headers = config.headers) ? _config_headers : {};
                config.headers[RESPONSE_JWT_KEY] = jwt;
                return config;
            }
        ]
    };
}
exports.jwtPlugin = __webpack_exports__.jwtPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "jwtPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
